export default "__VITE_ASSET__BuR2_xDB__"